/* VitaFresh Gericht-Karte und Quick-View (snippets/vf-gericht-karte.liquid, sections/vf-gericht-quick.liquid), Pasci 10.10.2026.
   1. Grösse: Radios name="id" tragen die fertigen Texte ihrer Grösse (data-preis = variant.price | money, Nährwerte, Gewicht).
      Bei «change» tauscht <vf-gericht-karte> nur Texte, blendet Grössenblöcke (data-vfgk-v) ein und markiert Tabellenzeilen
      (data-vfgk-markiert). Nichts wird gerechnet oder gerundet.
   2. Warenkorb: Hinzufügen nur über das Theme-Element <product-form data-ajax-cart> (component-product-form.js). Die Zahl im
      Zähler (− n +) kommt immer aus /cart.js: geladen beim Start, nach add-to-cart, bei cart-updated und Kopfzähler nur,
      wenn die Kopfzahl vom bekannten Stand abweicht, und wenn die Seite wieder sichtbar wird (gebündelt, alte Anfrage
      abgebrochen). «−» setzt die Zeile per /cart/change.js um eins tiefer, übernimmt die Antwort und ruft danach
      window.refreshCart() (Drawer, Kopfzähler, Kühltasche, Rabatt-Balken; meldet cart-updated mit demselben Stand).
      Gezählt werden nur einfache Zeilen (ohne Abo/selling_plan, ohne Eigenschaften), wie sie der Karten-Knopf anlegt;
      Portal- und Abo-Zeilen fasst «−» nie an. Solange eine Änderung der Zone läuft, sind «−» und «+» gesperrt.
      «Mehr davon ist gerade nicht verfügbar» erscheint nur, wenn eine /cart.js-Antwort, die nach dem eigenen add-to-cart
      gestartet wurde, die erwartete Menge nicht zeigt (Prüfrunde 1).
   3. Quick-View: Knopf (i) oder Foto holt per Section Rendering nur sections/vf-gericht-quick.liquid in ein gemeinsames
      <dialog> (Antworten je Gericht gemerkt, höchstens QV_CACHE_MAX). Übernimmt Grösse und Filter-Hinweise der Karte.
      Reiter mit Pfeiltasten, Esc und Hintergrund schliessen, Fokus zurück auf (i), Seite dahinter scrollt nicht.
      Beschreibung am Computer ohne Scrollbalken: passt sie nicht, wird sie auf ganze Zeilen gekürzt («Mehr lesen»).
   Reine Logik (werteFuerVariante, metaText, passtText, sichtbarkeit, mengenAusWarenkorb, minusAenderung, offenAuswerten, korbAnsicht,
   zeilenFuerText, tabZiel, weiterRechts, plusGescheitert) ist DOM-frei und in Node testbar: node --test tests/vf-gericht-karte.test.js */
(function (root) {
  "use strict";
  /* Doppelt eingebunden (z. B. Section und Nachladen aus assets/vf-quick-oeffnen.js): nur das erste Mal, sonst zwei Warenkorb-Stände */
  if (root.vfGerichtQuick) return;

  var FELDER = ["preis", "kcal", "protein", "kh", "fett"];
  var PASST_NICHT = ["groesse", "naehrwert", "preis"]; /* data-passt einer Grösse, Hinweistext aus data-text-<status> */
  var KORB_WARTEN_MS = 120;      /* mehrere Auslöser kurz hintereinander = eine Abfrage von /cart.js */
  var KORB_FRIST_MS = 10000;     /* «+» ohne jede Rückmeldung des Themes: Zähler nach dieser Zeit frei geben (mit Hinweis) */
  var QV_CACHE_MAX = 12;
  var QV_SECTION = "vf-gericht-quick";
  var QV_COMPUTER = "(min-width: 900px)";
  var TEXT_MIN_ZEILEN = 2;
  var TEXT_ZEILEN_HANDY = 3;
  var HINWEIS_MS = 3500;
  var TEXT_FEHLER = "Das hat gerade nicht geklappt. Bitte versuche es gleich nochmals.";
  var TEXT_NICHT_MEHR = "Mehr davon ist gerade nicht verfügbar.";
  var TEXT_QV_FEHLER = "Die Angaben konnten gerade nicht geladen werden. Bitte versuche es gleich nochmals.";

  /* ---------- reine Logik ---------- */

  /* Anzeigetexte einer Grösse aus den data-Attributen des Radios. Fehlender Nährwert: «–»; fehlender Preis: leer (nie 0). */
  function werteFuerVariante(daten) {
    var aus = {};
    FELDER.forEach(function (f) {
      var v = daten && daten[f] != null ? String(daten[f]).trim() : "";
      aus[f] = f === "preis" ? v : (v === "" ? "–" : v);
    });
    return aus;
  }

  /* Portionszeile: immer die Portion der gewählten Grösse, nie der Filter-Hinweis (eigene Zeile, passtText; Pasci
     11.10.2026). texte = { portion, ohne } aus data-text-*, [groesse] und [gewicht] werden ersetzt. */
  function metaText(daten, texte) {
    daten = daten || {};
    texte = texte || {};
    var gewicht = String(daten.gewicht || "").trim();
    var vorlage = gewicht ? texte.portion : texte.ohne;
    return String(vorlage || "").replace("[groesse]", String(daten.groesse || "")).replace("[gewicht]", gewicht);
  }

  /* Filter-Hinweis der gewählten Grösse: data-passt «groesse», «naehrwert» oder «preis» → Text aus texte (data-text-*,
     «Grösse passt nicht» usw.), sonst leer (passt bzw. unbekannter Status). */
  function passtText(passt, texte) {
    texte = texte || {};
    return PASST_NICHT.indexOf(passt) !== -1 ? String(texte[passt] || "") : "";
  }

  /* Je Element: versteckt (true) oder sichtbar (false) für die gewählte Variante; gibt es keinen Block dieser Variante,
     bleibt alles wie es ist (null). */
  function sichtbarkeit(ids, gewaehlt) {
    var ziel = String(gewaehlt);
    var gibt = ids.some(function (id) { return String(id) === ziel; });
    return ids.map(function (id) { return gibt ? String(id) !== ziel : null; });
  }

  /* /cart.js → Menge je Varianten-ID und die Zeilen (key, Menge) je Variante, nur aus einfachen Zeilen: Abo-Zeilen
     (selling_plan_allocation) und Zeilen mit Eigenschaften (Bestell-Portal, Liefertag) zählen nicht. Kaputte Einträge
     zählen nicht. anzahl = Kopfzahl, wie sie der Kopf zeigt: item_count ohne Kühltasche (VFWarenkorbBasis.anzeigeAnzahl, Pasci 21.10.2026). */
  function mengenAusWarenkorb(cart) {
    var mengen = {}, zeilen = {};
    var items = cart && Array.isArray(cart.items) ? cart.items : [];
    items.forEach(function (it) {
      if (!it || it.variant_id == null || !it.key) return;
      if (it.selling_plan_allocation || (it.properties && Object.keys(it.properties).length)) return;
      var n = Number(it.quantity);
      if (!(n > 0)) return;
      var id = String(it.variant_id);
      mengen[id] = (mengen[id] || 0) + n;
      (zeilen[id] = zeilen[id] || []).push({ key: String(it.key), menge: n });
    });
    return { mengen: mengen, zeilen: zeilen, anzahl: kopfAnzahl(cart) };
  }

  /* Zahl für den Kopfzähler aus /cart.js: ohne Kühltasche, aus der Warenkorb-Basis (eine Rechnung für alle Skripte). Fehlt die Basis
     (Seite ohne Layout-Kopf): item_count wie bisher. */
  var basisNode = null;
  if (typeof module !== "undefined" && module.exports) { try { basisNode = require("./vf-warenkorb-basis.js"); } catch (e) { basisNode = null; } }
  function kopfAnzahl(cart) {
    var b = root.VFWarenkorbBasis || basisNode;
    if (b && b.anzeigeAnzahl) return b.anzeigeAnzahl(cart);
    return cart && cart.item_count != null && !isNaN(Number(cart.item_count)) ? Number(cart.item_count) : null;
  }

  /* «−»: die letzte Zeile dieser Variante um eins senken (Aufruf für /cart/change.js) oder null. */
  function minusAenderung(zeilen) {
    if (!Array.isArray(zeilen) || !zeilen.length) return null;
    var z = zeilen[zeilen.length - 1];
    if (!z || !z.key || !(z.menge > 0)) return null;
    return { id: z.key, quantity: z.menge - 1 };
  }

  /* Offene «+» auswerten: nur die IDs in pruefen (deren add-to-cart vor dem Start der /cart.js-Abfrage kam). hinweis =
     mindestens eine hat die erwartete Menge (soll) nicht erreicht; erledigt = diese IDs sind abgeschlossen. */
  function offenAuswerten(mengen, offen, pruefen) {
    var erledigt = [], fehlt = false;
    (pruefen || []).forEach(function (id) {
      var o = offen && offen[id];
      if (!o) return;
      erledigt.push(id);
      if (((mengen && mengen[id]) || 0) < o.soll) fehlt = true;
    });
    return { hinweis: fehlt, erledigt: erledigt };
  }

  /* Was die Warenkorb-Zone zeigt: Zähler, sobald die Grösse im Warenkorb liegt, sonst den Knopf. */
  function korbAnsicht(menge) {
    return Number(menge) > 0 ? "zaehler" : "knopf";
  }

  /* Wie viele ganze Zeilen der Beschreibung passen: Texthöhe minus Überlauf minus Platz für «Mehr lesen». */
  function zeilenFuerText(textHoehe, ueberlauf, zeilenhoehe, reserve) {
    var lh = Number(zeilenhoehe) > 0 ? Number(zeilenhoehe) : 1;
    var frei = (Number(textHoehe) || 0) - (Number(ueberlauf) || 0) - (Number(reserve) || 0);
    return Math.max(TEXT_MIN_ZEILEN, Math.floor(frei / lh));
  }

  /* Tabelle breiter als ihr Platz und rechts noch Spalten verdeckt (z. B. Salz und Preis am Handy): Verlauf als Hinweis. */
  function weiterRechts(links, breite, sichtbar) {
    return Number(breite) - Number(sichtbar) - (Number(links) || 0) > 1;
  }

  /* «+» abgeschlossen ohne add-to-cart des Themes (Netzfehler: component-product-form.js meldet dann nichts, nimmt aber
     «working» vom Knopf): sofort freigeben und Hinweis statt die Zone bis zur Frist zu sperren (Prüfrunde 3). */
  function plusGescheitert(offen, arbeitet) {
    return !!offen && !!offen.gestartet && !arbeitet && !offen.quittiert;
  }

  /* Reiter-Tastatur (WAI-ARIA Tabs): Index des Ziel-Reiters oder -1. */
  function tabZiel(index, anzahl, taste) {
    if (!(anzahl > 0) || index < 0) return -1;
    switch (taste) {
      case "ArrowRight": return (index + 1) % anzahl;
      case "ArrowLeft": return (index - 1 + anzahl) % anzahl;
      case "Home": return 0;
      case "End": return anzahl - 1;
      default: return -1;
    }
  }

  if (typeof module !== "undefined" && module.exports) {
    module.exports = {
      werteFuerVariante: werteFuerVariante, metaText: metaText, passtText: passtText, sichtbarkeit: sichtbarkeit, mengenAusWarenkorb: mengenAusWarenkorb,
      minusAenderung: minusAenderung, offenAuswerten: offenAuswerten, korbAnsicht: korbAnsicht, zeilenFuerText: zeilenFuerText,
      tabZiel: tabZiel, weiterRechts: weiterRechts, plusGescheitert: plusGescheitert
    };
  }
  if (!root.document || !root.customElements || root.customElements.get("vf-gericht-karte")) return;

  var doc = root.document;

  function basis() {
    var r = root.Shopify && root.Shopify.routes && root.Shopify.routes.root;
    return typeof r === "string" && r ? r : "/";
  }

  function gewaehlt(wurzel) {
    return wurzel.querySelector('input[name="id"]:checked') || wurzel.querySelector('input[name="id"]');
  }

  /* Kurzer Hinweis unten (eine Live-Region für alle Karten). Bei offenem Quick-View im Dialog, sonst läge er unter
     der obersten Ebene und wäre unsichtbar. */
  var hinweisEl = null, hinweisTimer = null;
  function hinweis(text) {
    if (!hinweisEl) {
      hinweisEl = doc.createElement("div");
      hinweisEl.className = "vfgk-hinweis";
      hinweisEl.setAttribute("role", "status");
    }
    var ziel = qv.dialog && qv.dialog.open ? qv.dialog : doc.body;
    if (hinweisEl.parentNode !== ziel) ziel.appendChild(hinweisEl);
    hinweisEl.textContent = text;
    hinweisEl.classList.add("is-sichtbar");
    clearTimeout(hinweisTimer);
    hinweisTimer = setTimeout(function () { hinweisEl.classList.remove("is-sichtbar"); }, HINWEIS_MS);
  }

  /* ---------- Grösse anwenden ---------- */

  function textSetzen(el, text) {
    if (el.textContent !== text) el.textContent = text;
  }
  function metaSetzen(el, daten) {
    textSetzen(el, metaText(daten, { portion: el.getAttribute("data-text-portion"), ohne: el.getAttribute("data-text-ohne") }));
  }
  function passtSetzen(el, daten) {
    textSetzen(el, passtText(daten.passt, { groesse: el.getAttribute("data-text-groesse"), naehrwert: el.getAttribute("data-text-naehrwert"), preis: el.getAttribute("data-text-preis") }));
  }

  function anwenden(wurzel) {
    var radio = gewaehlt(wurzel);
    if (!radio) return;
    var werte = werteFuerVariante(radio.dataset);
    wurzel.querySelectorAll("[data-vfgk]").forEach(function (el) {
      var f = el.getAttribute("data-vfgk");
      if (Object.prototype.hasOwnProperty.call(werte, f) && el.textContent !== werte[f]) el.textContent = werte[f];
    });
    wurzel.querySelectorAll("[data-vfgk-meta]").forEach(function (el) { metaSetzen(el, radio.dataset); });
    /* Hinweis nur bei Bedarf (Pasci 11.10.2026): vfgk--passt nur, solange ein Hinweis Text hat; nur dann bekommt er eine Zeile */
    var hinweis = false;
    wurzel.querySelectorAll("[data-vfgk-passt]").forEach(function (el) { passtSetzen(el, radio.dataset); if (el.textContent !== "") hinweis = true; });
    if (wurzel.classList.contains("vfgk--passt") !== hinweis) wurzel.classList.toggle("vfgk--passt", hinweis);
    var bloecke = Array.prototype.slice.call(wurzel.querySelectorAll("[data-vfgk-v]"));
    var plan = sichtbarkeit(bloecke.map(function (b) { return b.getAttribute("data-vfgk-v"); }), radio.value);
    bloecke.forEach(function (b, i) { if (plan[i] !== null && b.hidden !== plan[i]) b.hidden = plan[i]; });
    wurzel.querySelectorAll("[data-vfgk-markiert]").forEach(function (z) { z.classList.toggle("is-gewaehlt", z.getAttribute("data-vfgk-markiert") === radio.value); });
    var aus = radio.hasAttribute("data-aus");
    var knopf = wurzel.querySelector("[data-js-product-add-to-cart]");
    if (knopf) {
      knopf.disabled = aus;
      if (aus) knopf.setAttribute("aria-disabled", "true"); else knopf.removeAttribute("aria-disabled");
      knopf.classList.remove("disabled"); /* setzt das Theme beim Grössenwechsel (section-main-product.css: opacity); hier gilt :disabled */
      var text = knopf.querySelector("[data-js-product-add-to-cart-text]");
      var soll = knopf.getAttribute(aus ? "data-text-aus" : "data-text-an");
      if (text && soll && text.textContent !== soll) text.textContent = soll;
    }
    korbZeigen(wurzel);
  }

  /* ---------- Warenkorb (Zahl aus /cart.js) ---------- */

  var ZAEHLER_OK_MS = 2000; /* Bestätigung am Zähler (Pasci 17.10.2026: 2 s) */
  var korb = { mengen: {}, zeilen: {}, anzahl: null, geladen: false, ctrl: null, timer: null, offen: {}, stand: 0 };

  function korbZeigen(wurzel) {
    var radio = gewaehlt(wurzel);
    var zone = wurzel.querySelector("[data-vfgk-korb]");
    if (!radio || !zone) return;
    var menge = korb.mengen[radio.value] || 0;
    var ansicht = korbAnsicht(menge);
    var knopf = zone.querySelector("[data-js-product-add-to-cart]");
    var zaehler = zone.querySelector("[data-vfgk-zaehler]");
    if (!knopf || !zaehler) return;
    /* Fokus mitnehmen, wenn das fokussierte Element verschwindet (Enter auf «In den Warenkorb», «−» auf 0) */
    var aktiv = doc.activeElement;
    var fokusWeg = !!aktiv && ((ansicht === "zaehler" && aktiv === knopf) || (ansicht !== "zaehler" && zaehler.contains(aktiv)));
    if (knopf.hidden !== (ansicht === "zaehler")) knopf.hidden = ansicht === "zaehler";
    if (zaehler.hidden !== (ansicht !== "zaehler")) zaehler.hidden = ansicht !== "zaehler";
    if (fokusWeg) {
      var ziel = ansicht === "zaehler" ? zaehler.querySelector("[data-vfgk-plus]") : knopf;
      if (ziel && !ziel.disabled) ziel.focus();
    }
    var zahl = zaehler.querySelector("[data-vfgk-menge]");
    if (zahl && zahl.textContent !== String(menge)) zahl.textContent = String(menge);
    var plus = zaehler.querySelector("[data-vfgk-plus]");
    if (plus) plus.disabled = radio.hasAttribute("data-aus");
  }

  function alleKorbZeigen() {
    doc.querySelectorAll("vf-gericht-karte").forEach(korbZeigen);
  }

  /* pruefen: offene «+», die diese Antwort auswerten darf (siehe offenAuswerten); die übrigen bleiben offen. */
  function korbUebernehmen(cart, pruefen) {
    korb.stand++;
    var z = mengenAusWarenkorb(cart);
    korb.mengen = z.mengen;
    korb.zeilen = z.zeilen;
    korb.anzahl = z.anzahl;
    korb.geladen = true;
    var a = offenAuswerten(korb.mengen, korb.offen, pruefen);
    var bestaetigt = [];
    a.erledigt.forEach(function (id) {
      var o = korb.offen[id];
      if ((korb.mengen[id] || 0) >= o.soll) bestaetigt.push(o.zone);
      plusAufraeumen(o);
      delete korb.offen[id];
    });
    if (a.hinweis) hinweis(TEXT_NICHT_MEHR);
    alleKorbZeigen();
    bestaetigt.forEach(zaehlerBestaetigen);
  }

  /* Sichtbare Bestätigung nach «In den Warenkorb» bzw. «+» (Pasci 17.10.2026): Der Zähler steht ZAEHLER_OK_MS lang
     dunkelgrün mit «✓», danach wieder normal. Nur wenn die Menge wirklich angekommen ist. */
  function zaehlerBestaetigen(zone) {
    var zaehler = zone && zone.querySelector("[data-vfgk-zaehler]");
    if (!zaehler) return;
    zaehler.classList.add("vfgk__zaehler--ok");
    clearTimeout(zaehler._vfgkOk);
    zaehler._vfgkOk = setTimeout(function () { zaehler.classList.remove("vfgk__zaehler--ok"); }, ZAEHLER_OK_MS);
  }

  function korbLaden() {
    if (korb.ctrl) korb.ctrl.abort();
    var ctrl = typeof AbortController === "function" ? new AbortController() : null;
    korb.ctrl = ctrl;
    var pruefen = Object.keys(korb.offen).filter(function (id) { return korb.offen[id].quittiert; });
    var stand = korb.stand;
    root.fetch(basis() + "cart.js", { signal: ctrl ? ctrl.signal : undefined, headers: { Accept: "application/json" }, credentials: "same-origin" })
      .then(function (r) { if (!r.ok) throw new Error("HTTP " + r.status); return r.json(); })
      .then(function (cart) {
        /* Inzwischen hat eine eigene Änderung («−») einen neueren Stand gebracht: diese Antwort ist älter (Prüfrunde 3) */
        if (stand !== korb.stand) { korbPlanen(); return; }
        korbUebernehmen(cart, pruefen);
      })
      .catch(function () { /* Zähler bleibt beim letzten Stand; Knopf funktioniert weiter über das Theme */ })
      .then(function () { if (korb.ctrl === ctrl) korb.ctrl = null; });
  }

  function korbPlanen() {
    clearTimeout(korb.timer);
    korb.timer = setTimeout(korbLaden, KORB_WARTEN_MS);
  }

  /* Kopfzähler geändert: nur neu laden, wenn er nicht dem bekannten Stand entspricht (z. B. eigene «−»-Änderung). */
  function kopfGeaendert() {
    var el = doc.querySelector("[data-header-cart-count]");
    var n = el ? parseInt(el.textContent, 10) : NaN;
    if (!korb.geladen || isNaN(n) || n !== korb.anzahl) korbPlanen();
  }

  function themaAuffrischen(cart) {
    if (typeof root.refreshCart === "function" && doc.getElementById("AjaxCartForm")) {
      try { root.refreshCart(); return; } catch (e) { /* weiter mit Rückfall */ }
    }
    var n = kopfAnzahl(cart);
    if (n !== null) doc.querySelectorAll("[data-header-cart-count]").forEach(function (el) { el.textContent = String(n); });
  }

  /* add-to-cart des Theme-Formulars (<product-form>): offene «+» dieses Formulars dürfen jetzt ausgewertet werden. */
  function korbQuittieren(ev) {
    var form = ev && ev.target;
    Object.keys(korb.offen).forEach(function (id) {
      var o = korb.offen[id];
      if (form && form.contains && form.contains(o.zone)) o.quittiert = true;
    });
    korbPlanen();
  }

  function korbPlus(wurzel, zone, ev) {
    var radio = gewaehlt(wurzel);
    if (!radio) return;
    if (zone.getAttribute("aria-busy") === "true") { ev.preventDefault(); return; } /* «−» oder «+» läuft noch */
    var id = radio.value;
    var alt = korb.offen[id]; /* dieselbe Grösse offen in der anderen Zone (Karte bzw. Quick-View): diese freigeben */
    if (alt) plusAufraeumen(alt);
    zone.setAttribute("aria-busy", "true");
    var o = korb.offen[id] = {
      soll: (korb.mengen[id] || 0) + 1, zone: zone,
      frist: setTimeout(function () { plusFrei(id, o); }, KORB_FRIST_MS)
    };
    /* Das Theme setzt «working» an den ersten Submit-Knopf seines Formulars und nimmt es nach dem Abruf wieder weg; kam
       bis dahin kein add-to-cart, ist der Abruf gescheitert. */
    var form = zone.closest("product-form");
    var knopf = form ? form.querySelector('[type="submit"]') : null;
    if (knopf && typeof root.MutationObserver === "function") {
      o.beobachter = new root.MutationObserver(function () {
        var arbeitet = knopf.classList.contains("working");
        if (arbeitet) o.gestartet = true;
        if (korb.offen[id] === o && plusGescheitert(o, arbeitet)) plusFrei(id, o);
      });
      o.beobachter.observe(knopf, { attributes: true, attributeFilter: ["class"] });
    }
    /* Kein preventDefault: der Submit geht an <product-form> (Theme). */
  }

  /* Offenes «+» ohne Antwort bzw. gescheitert: Zone frei, Hinweis, Zahl neu laden. */
  function plusFrei(id, o) {
    plusAufraeumen(o);
    if (korb.offen[id] !== o) return;
    delete korb.offen[id];
    hinweis(TEXT_FEHLER);
    korbPlanen();
  }

  function plusAufraeumen(o) {
    clearTimeout(o.frist);
    if (o.beobachter) o.beobachter.disconnect();
    o.zone.removeAttribute("aria-busy");
  }

  function korbMinus(wurzel, zone) {
    var radio = gewaehlt(wurzel);
    var aenderung = radio ? minusAenderung(korb.zeilen[radio.value]) : null;
    /* Gesperrt, solange in dieser Zone etwas läuft oder dieselbe Grösse in der anderen Zone ein offenes «+» hat (Karte bzw.
       Quick-View): sonst ginge /cart/change.js mit einer veralteten Zeilenmenge raus (Prüfrunde 2). */
    if (!aenderung || zone.getAttribute("aria-busy") === "true" || korb.offen[radio.value]) return;
    zone.setAttribute("aria-busy", "true");
    /* Laufende bzw. geplante Abfrage von /cart.js verwerfen: ihr Stand wäre älter als die Antwort von change.js */
    clearTimeout(korb.timer);
    if (korb.ctrl) { korb.ctrl.abort(); korb.ctrl = null; }
    root.fetch(basis() + "cart/change.js", {
      method: "POST", credentials: "same-origin",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify(aenderung)
    })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); })
      .then(function (cart) { korbUebernehmen(cart, []); themaAuffrischen(cart); })
      .catch(function () { hinweis(TEXT_FEHLER); korbPlanen(); })
      .then(function () { zone.removeAttribute("aria-busy"); });
  }

  var korbGestartet = false;
  function korbStarten() {
    if (korbGestartet) return;
    korbGestartet = true;
    korbPlanen();
    doc.addEventListener("add-to-cart", korbQuittieren);
    /* meldet <cart-form> ohne bubbles: in der Capture-Phase hören. Wie der Kopfzähler nur laden, wenn der Stand abweicht: nach
       dem eigenen «−» meldet refreshCart denselben Stand noch einmal (seit 16.10.2026), das braucht kein zweites /cart.js */
    doc.addEventListener("cart-updated", kopfGeaendert, true);
    root.addEventListener("pageshow", function (e) { if (e.persisted) korbPlanen(); });
    doc.addEventListener("visibilitychange", function () { if (!doc.hidden) korbPlanen(); });
    if (typeof root.MutationObserver === "function") {
      var mo = new root.MutationObserver(kopfGeaendert);
      doc.querySelectorAll("[data-header-cart-count]").forEach(function (el) { mo.observe(el, { childList: true, characterData: true, subtree: true }); });
    }
  }

  /* ---------- Quick-View ---------- */

  var qv = { dialog: null, zurueck: null, handle: "", cache: [], ctrl: null, laeuft: null };

  function qvDialog() {
    if (qv.dialog) return qv.dialog;
    var d = doc.createElement("dialog");
    d.className = "vfp vfgk-dialog";
    d.addEventListener("click", function (ev) { if (ev.target === d) d.close(); });
    d.addEventListener("close", function () {
      doc.documentElement.classList.remove("vfgk-dialog-offen");
      d.innerHTML = "";
      d.removeAttribute("aria-labelledby");
      var z = qv.zurueck;
      qv.zurueck = null;
      /* Raster inzwischen neu geladen (Filter): Fokus auf (i) derselben Karte im neuen Raster (Prüfrunde 3) */
      if (z && !doc.contains(z)) z = qvAusloeser(qv.handle);
      if (z && z.focus) z.focus();
    });
    /* Tabellen: Verlauf am Rand nachführen, wenn gewischt wird (scroll steigt nicht auf, darum Capture) */
    d.addEventListener("scroll", function (ev) { if (ev.target.classList && ev.target.classList.contains("vfgk-qv__tabelle")) tabelleHinweis(ev.target); }, true);
    doc.body.appendChild(d);
    root.addEventListener("resize", entprellt(function () { var w = d.querySelector("[data-vfgk-qv]"); if (d.open && w) { textEinpassen(w); tabellenHinweis(w); } }, 150));
    qv.dialog = d;
    return d;
  }

  function entprellt(fn, ms) {
    var t = null;
    return function () { clearTimeout(t); t = setTimeout(fn, ms); };
  }

  function qvAusloeser(handle) {
    if (!handle) return null;
    var karten = doc.querySelectorAll("vf-gericht-karte:not([data-vfgk-qv])");
    for (var i = 0; i < karten.length; i++) if (karten[i].getAttribute("data-handle") === handle) return karten[i].querySelector(".vfgk__info");
    return null;
  }

  function tabelleHinweis(t) {
    t.classList.toggle("is-weiter", weiterRechts(t.scrollLeft, t.scrollWidth, t.clientWidth));
  }
  function tabellenHinweis(w) {
    w.querySelectorAll(".vfgk-qv__tabelle").forEach(tabelleHinweis);
  }

  function ausCache(url) {
    for (var i = 0; i < qv.cache.length; i++) if (qv.cache[i].url === url) return qv.cache[i].html;
    return null;
  }
  function inCache(url, html) {
    qv.cache.push({ url: url, html: html });
    if (qv.cache.length > QV_CACHE_MAX) qv.cache.shift();
  }

  /* Grösse und Filter-Hinweise einer Karte in den Quick-View übernehmen. */
  function vonKarte(karte) {
    return function (w) {
      var quelle = gewaehlt(karte);
      karte.querySelectorAll('input[name="id"]').forEach(function (kr) {
        var qr = w.querySelector('input[name="id"][value="' + kr.value + '"]');
        if (!qr) return;
        if (kr.hasAttribute("data-passt")) qr.setAttribute("data-passt", kr.getAttribute("data-passt")); else qr.removeAttribute("data-passt");
        /* Screenreader-Hinweis wie auf der Karte: Liquid gibt ihn seit 21.10.2026 nur mit Filter aus (SEO), der Quick-View
           kommt ohne Filter-Stand vom Shop, darum hier übernehmen bzw. entfernen. */
        var kl = karte.querySelector('label[for="' + kr.id + '"] .vfgk__passt-sr'), ql = w.querySelector('label[for="' + qr.id + '"]');
        var qs = ql && ql.querySelector(".vfgk__passt-sr");
        if (kl && ql && !qs) ql.insertBefore(kl.cloneNode(true), ql.firstChild ? ql.firstChild.nextSibling : null);
        else if (!kl && qs) qs.remove();
        if (quelle && kr.value === quelle.value && !qr.disabled) qr.checked = true;
      });
    };
  }

  /* uebernehmen(w): stellt die Grösse im neuen Inhalt ein; handle: Karte, deren (i) nach dem Schliessen den Fokus bekommt,
     falls zurueck inzwischen nicht mehr im Dokument ist. */
  function qvZeigen(html, uebernehmen, zurueck, handle) {
    var d = qvDialog();
    d.innerHTML = html; /* eigenes Shop-Markup aus der Section, keine Nutzereingabe */
    var w = d.querySelector("[data-vfgk-qv]");
    if (!w) return;
    uebernehmen(w);
    anwenden(w);
    var titel = w.getAttribute("data-vfgk-titel-id");
    if (titel) d.setAttribute("aria-labelledby", titel);
    qv.zurueck = zurueck;
    qv.handle = handle || "";
    doc.documentElement.classList.add("vfgk-dialog-offen");
    if (!d.open) { if (typeof d.showModal === "function") d.showModal(); else d.setAttribute("open", ""); }
    textEinpassen(w);
    tabellenHinweis(w);
    var zu = w.querySelector("[data-vfgk-zu]");
    if (zu) zu.focus();
  }

  function qvOeffnen(ausloeser, karte) {
    var pfad = ausloeser.getAttribute("data-vfgk-quick");
    if (!pfad) return;
    qvLaden(pfad, karte.querySelector(".vfgk__info") || ausloeser, vonKarte(karte), karte.getAttribute("data-handle") || "");
  }

  /* pfad: /products/<handle>; info: Auslöser (aria-busy, Fokus nach dem Schliessen); uebernehmen, handle: siehe qvZeigen. */
  function qvLaden(pfad, info, uebernehmen, handle) {
    var url = pfad + (pfad.indexOf("?") === -1 ? "?" : "&") + "section_id=" + QV_SECTION;
    /* Ein laufender Abruf (anderes Gericht) verfällt immer, auch bei einem Treffer im Speicher: sonst ersetzt seine
       spätere Antwort den offenen Dialog (Prüfrunde 3). */
    if (qv.ctrl) qv.ctrl.abort();
    qv.ctrl = null;
    if (qv.laeuft) qv.laeuft.removeAttribute("aria-busy");
    qv.laeuft = null;
    var fertig = ausCache(url);
    if (fertig) { qvZeigen(fertig, uebernehmen, info, handle); return; }
    var ctrl = typeof AbortController === "function" ? new AbortController() : null;
    qv.ctrl = ctrl;
    qv.laeuft = info;
    info.setAttribute("aria-busy", "true");
    root.fetch(url, { signal: ctrl ? ctrl.signal : undefined, headers: { Accept: "text/html" }, credentials: "same-origin" })
      .then(function (r) { if (!r.ok) throw new Error("HTTP " + r.status); return r.text(); })
      .then(function (text) {
        if (qv.ctrl !== ctrl) return;
        var teil = new DOMParser().parseFromString(text, "text/html").querySelector("[data-vfgk-quick-inhalt]");
        if (!teil || !teil.querySelector("[data-vfgk-qv]")) throw new Error("Quick-View ohne Inhalt");
        inCache(url, teil.innerHTML);
        qvZeigen(teil.innerHTML, uebernehmen, info, handle);
      })
      .catch(function (e) { if (qv.ctrl === ctrl && (!e || e.name !== "AbortError")) hinweis(TEXT_QV_FEHLER); })
      .then(function () {
        if (qv.ctrl !== ctrl) return;
        qv.ctrl = null;
        qv.laeuft = null;
        info.removeAttribute("aria-busy");
      });
  }

  /* Beschreibung: am Computer auf ganze Zeilen kürzen, wenn die linke Spalte sonst überläuft (gemessen, ein Durchgang);
     am Handy drei Zeilen. «Mehr lesen» zeigt alles (links scrollt dann ohne sichtbaren Balken). */
  function textEinpassen(w) {
    var links = w.querySelector("[data-vfgk-qv-links]");
    var text = w.querySelector("[data-vfgk-qv-text]");
    var mehr = w.querySelector("[data-vfgk-qv-mehr]");
    if (!links || !text || !mehr) return;
    text.style.maxHeight = "";
    text.classList.remove("is-gekuerzt");
    links.classList.remove("is-offen");
    mehr.setAttribute("aria-expanded", "false");
    mehr.textContent = "Mehr lesen";
    mehr.hidden = true;
    var lh = parseFloat(root.getComputedStyle(text).lineHeight) || 23;
    var zeilen;
    if (root.matchMedia(QV_COMPUTER).matches) {
      var ueber = links.scrollHeight - links.clientHeight;
      if (ueber <= 0) return;
      mehr.hidden = false;
      zeilen = zeilenFuerText(text.clientHeight, ueber, lh, mehr.offsetHeight);
    } else {
      if (text.scrollHeight <= TEXT_ZEILEN_HANDY * lh + 2) return;
      mehr.hidden = false;
      zeilen = TEXT_ZEILEN_HANDY;
    }
    text.style.maxHeight = zeilen * lh + "px";
    text.classList.add("is-gekuerzt");
  }

  function textUmschalten(w, mehr) {
    var text = w.querySelector("[data-vfgk-qv-text]");
    if (!text) return;
    if (!text.classList.contains("is-gekuerzt")) { textEinpassen(w); return; }
    text.classList.remove("is-gekuerzt");
    text.style.maxHeight = "";
    var links = w.querySelector("[data-vfgk-qv-links]");
    if (links) links.classList.add("is-offen");
    mehr.setAttribute("aria-expanded", "true");
    mehr.textContent = "Weniger";
  }

  function tabWaehlen(w, tab, fokus) {
    var tabs = w.querySelectorAll('[role="tab"]');
    tabs.forEach(function (t) {
      var an = t === tab;
      t.setAttribute("aria-selected", an ? "true" : "false");
      t.tabIndex = an ? 0 : -1;
      var tafel = doc.getElementById(t.getAttribute("aria-controls"));
      if (tafel) tafel.hidden = !an;
    });
    if (fokus) tab.focus();
    if (tab.scrollIntoView) tab.scrollIntoView({ block: "nearest", inline: "nearest" });
    var tafeln = w.querySelector(".vfgk-qv__tafeln");
    if (tafeln) tafeln.scrollTop = 0;
    tabellenHinweis(w);
  }

  /* Quick-View ohne Karte, z. B. für die Favoriten in «Mein Konto» (assets/vf-konto.js): pfad /products/<handle>,
     varianteId wählt die Grösse vor (wenn lieferbar), zurueck bekommt nach dem Schliessen den Fokus. */
  root.vfGerichtQuick = function (pfad, varianteId, zurueck) {
    if (typeof pfad !== "string" || !/^\/products\/[^\/?#]+$/.test(pfad) || !zurueck) return;
    var id = String(varianteId == null ? "" : varianteId);
    qvLaden(pfad, zurueck, function (w) {
      var r = /^\d+$/.test(id) ? w.querySelector('input[name="id"][value="' + id + '"]') : null;
      if (r && !r.disabled) r.checked = true;
    }, "");
  };

  /* ---------- Element ---------- */

  root.customElements.define("vf-gericht-karte", class extends HTMLElement {
    connectedCallback() {
      if (this._vfgk) { anwenden(this); return; }
      this._vfgk = true;
      /* Skript läuft: volle Grössenwahl, auch wenn das Inline-Skript der Section nicht lief (Theme-Editor) */
      var ohne = this.closest(".vfgk-ohne-js");
      if (ohne) ohne.classList.remove("vfgk-ohne-js");
      var w = this;
      w.addEventListener("change", function (ev) {
        /* Radio der Karte bzw. auf der Gerichtseite das versteckte Feld id (Theme und assets/vfp-gericht.js melden change) */
        if (ev.target && ev.target.matches && ev.target.matches('input[name="id"]')) anwenden(w);
      });
      w.addEventListener("click", function (ev) {
        var t = ev.target && ev.target.closest ? ev.target.closest("[data-vfgk-quick],[data-vfgk-minus],[data-vfgk-plus],.vfgk__knopf,[data-vfgk-zu],[data-vfgk-qv-mehr],[role=\"tab\"]") : null;
        if (!t || !w.contains(t)) return;
        var zone = t.closest("[data-vfgk-korb]");
        /* «In den Warenkorb» läuft wie «+»: so bestätigt der Zähler, der den Knopf ersetzt (sonst blitzte «✓» am Knopf nur kurz) */
        if (t.hasAttribute("data-vfgk-plus") || (zone && t.classList.contains("vfgk__knopf"))) { korbPlus(w, zone, ev); return; }
        if (t.hasAttribute("data-vfgk-quick") && t.tagName === "A" && (ev.metaKey || ev.ctrlKey || ev.shiftKey || ev.altKey)) return; /* Foto in neuem Tab/Fenster */
        ev.preventDefault();
        if (t.hasAttribute("data-vfgk-quick")) qvOeffnen(t, w);
        else if (t.hasAttribute("data-vfgk-minus")) korbMinus(w, zone);
        else if (t.hasAttribute("data-vfgk-zu")) { var d = w.closest("dialog"); if (d) d.close(); }
        else if (t.hasAttribute("data-vfgk-qv-mehr")) textUmschalten(w, t);
        else tabWaehlen(w, t, false);
      });
      w.addEventListener("keydown", function (ev) {
        var t = ev.target;
        if (!t || t.getAttribute("role") !== "tab") return;
        var tabs = Array.prototype.slice.call(w.querySelectorAll('[role="tab"]'));
        var j = tabZiel(tabs.indexOf(t), tabs.length, ev.key);
        if (j < 0) return;
        ev.preventDefault();
        tabWaehlen(w, tabs[j], true);
      });
      anwenden(w); /* Zurück-Taste stellt alte Radio-Zustände her: Anzeige angleichen */
      korbStarten();
    }
  });
})(typeof window !== "undefined" ? window : globalThis);
